import { adminQuery } from '../adminQuery';

interface Params {
  username: string;
  groupname: string;
}

export const adminAddUserToGroup = async (body: Params) => {
  return await adminQuery.post({
    path: '/addUserToGroup',
    params: {
      body,
    },
  });
};
